import { Space, Tag, Typography } from 'antd'

const { Text } = Typography

function hasEmployeeOverallRating (appraisal) {
  return Boolean(appraisal?.employee_overall_rating)
}

function hasFinalOverallRating (appraisal) {
  return Boolean(appraisal?.approver_overall_rating)
}

function supportsEmployeeOverallRating (appraisal) {
  if (typeof appraisal?.supports_employee_overall_rating === 'boolean') {
    return appraisal.supports_employee_overall_rating
  }
  return hasEmployeeOverallRating(appraisal)
}

export function ratingDisplayLabel (value) {
  if (!value) return ''
  const normalizedValue = value.toLowerCase().replace(/[^a-z0-9]/g, '')
  if (['newposition', 'newinposition', 'newinpositionnew'].includes(normalizedValue)) {
    return 'New in Position'
  }
  if (/^[a-z0-9]+(?:[_-][a-z0-9]+)+$/.test(value)) {
    return value
      .split(/[_-]/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }
  return value
}

export function CompletedRating ({ appraisal, field }) {
  const rating = ratingDisplayLabel(appraisal[field])
  if (rating) return rating
  return <Text type='secondary'>{appraisal.status === 'completed' ? 'Not rated' : '—'}</Text>
}

export function completedRatingColumns (appraisals = []) {
  const columns = []

  if ((appraisals || []).some(supportsEmployeeOverallRating)) {
    columns.push({
      title: 'Employee Rating',
      key: 'employee_rating',
      render: (_, appraisal) => <CompletedRating appraisal={appraisal} field='employee_overall_rating' />
    })
  }

  if ((appraisals || []).some(hasFinalOverallRating)) {
    columns.push({
      title: 'Manager Rating',
      key: 'approver_rating',
      render: (_, appraisal) => <CompletedRating appraisal={appraisal} field='approver_overall_rating' />
    })
  }

  return columns
}

export default function CompletedAppraisalRatings ({ appraisal }) {
  const showEmployeeRating = supportsEmployeeOverallRating(appraisal) && (
    appraisal.status === 'completed' || hasEmployeeOverallRating(appraisal)
  )
  const showApproverRating = hasFinalOverallRating(appraisal)
  if (!showEmployeeRating && !showApproverRating) return null

  return (
    <Space size={[4, 4]} wrap>
      {showEmployeeRating && (
        <Tag>Employee Rating: {ratingDisplayLabel(appraisal.employee_overall_rating) || 'Not rated'}</Tag>
      )}
      {showApproverRating && (
        <Tag color='blue'>Manager Rating: {ratingDisplayLabel(appraisal.approver_overall_rating)}</Tag>
      )}
    </Space>
  )
}
